import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button, Modal } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';
import ModalMap from '../utils/ticket/ModalMap.js';
import TicketMap from '../pages/ticketMap/TicketMap.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';




export default function DataGridLastTdHook({ item, props, entity = null}) {

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        
    }, []);



    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch(entity) {
                        case 'ticket' : 
                            return (
                                <>
                                <Button className='btn-sm me-2' link={true} as={Link} to={`/entity/ticket/edit?id=${item.id}`}>Modifica</Button>
                                <ModalMap data={item} show={showModal} setShow={setShowModal} />

                                <Button className='btn-sm btn-outline-secondary me-2 bg-transparent' onClick={() => setShowModal(true)} ><FontAwesomeIcon icon={'map'} /></Button>
                                </>
                        );
                        case 'gyv_ticket_open' : 
                            return (
                                <>
                                <Button className='btn-sm me-2' link={true} as={Link} to={`/entity/ticket/edit?id=${item.id}`}>Modifica</Button>
                                <ModalMap data={item} show={showModal} setShow={setShowModal} />

                                <Button className='btn-sm btn-outline-secondary me-2 bg-transparent' onClick={() => setShowModal(true)} ><FontAwesomeIcon icon={'map'} /></Button>
                                </>
                        );
                        case 'gyv_ticket_in_progress' : 
                            return (
                                <>
                                <Button className='btn-sm me-2' link={true} as={Link} to={`/entity/ticket/edit?id=${item.id}`}>Modifica</Button>
                                <ModalMap data={item} show={showModal} setShow={setShowModal} />

                                <Button className='btn-sm btn-outline-secondary me-2 bg-transparent' onClick={() => setShowModal(true)} ><FontAwesomeIcon icon={'map'} /></Button>
                                </>
                        );
                        case 'gyv_ticket_closed' : 
                            return (
                                <>
                                <Button className='btn-sm me-2' link={true} as={Link} to={`/entity/ticket/edit?id=${item.id}`}>Modifica</Button>
                                <ModalMap data={item} show={showModal} setShow={setShowModal} />

                                <Button className='btn-sm btn-outline-secondary me-2 bg-transparent' onClick={() => setShowModal(true)} ><FontAwesomeIcon icon={'map'} /></Button>
                                </>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};